<section class="pageTop">
    <div class="container mxw-1100">
        <div class="row column-reverse">
            <div class="col-md-7">
                <div class="pageText">
                    <h1><span class="regular">What is</span><br>CNC Machining?</h1>
                    <p>A computer numerical control (CNC) machine can be used in many different ways to manufacture parts. It can be used to 3D print using polymer materials, it can be used as a conveyor system fed by lasers and sensors, or it can be used as a pick-and-place solder machine for semiconductor production.</p>
                    <p>Typically thought of as autonomous metalworking machines cutting raw materials into their finished product, CNC machines have evolved into 3 different categories.</p>
                    <p>CNC machining was originally a manual process, used during the Industrial Revolution. CNC operators manually cranked handwheels and adjusted cutting tools to complete projects.</p>
                </div>
            </div>
            <div class="col-md-5">
                <div class="pageImg">
                    <img src="../../../../assets/images/services_page.gif" alt="">
                    <!-- <img src="../../../../assets/images/report.png" alt=""> -->
                </div>
            </div>
        </div>
    </div>
</section>

<section>
    <div class="container mxw-1100">
        <div class="row">
            <div class="col-md-5">
                <div class="serviceImg">
                    <img src="../../../../assets/images/PP__3604 1.png" alt="">
                </div>
            </div>
            <div class="col-md-7 align-self">
                <div class="serviceText">
                    <h2><span class="regular">Advantages of</span> CNC Machining</h2>
                    <p>Medical CNC machining with MMPAS is easy. Our AI-powered instant quote tool allows you to quickly see the feasibility of manufacturing your part, while our extensive manufacturing network ensures your parts will be made to exact specifications, fast.</p>
                    <p class="mb-5">For more information see below: </p>
                    <ul class="mobile-margin-0">
                        <li><mat-icon>check</mat-icon> Precision Components</li>
                        <li><mat-icon>check</mat-icon> Rapid Turnaround of Parts</li>
                        <li><mat-icon>check</mat-icon> Extensive Manufacturing Capability and Capacity</li>
                    </ul>
                    <button mat-button class="btn-custom btn-solid hide-mobile">Get Started</button>
                </div>
            </div>
            
        </div>
    </div>
</section>

<section class="mobile-padding-0">
    <div class="container">
        <h2 class="text-center text-left-mobile">CNC Machine <span class="regular">Application</span></h2>
        <p class="text-center text-left-mobile mb-40">We provide best in class post production processes and  post manufacturing to get the well finished goods to be proud on. Also, <br>we help you in getting the samples checked while we are building the products.</p>
        
        <div class="row">
            <div class="col-sm-4">
                <div class="applicationWrpp">
                    <div class="appliIco">
                        <img src="../../../../assets/images/rapid-tooling.png" alt="">
                        <span>01</span>
                    </div>
                    <div class="appliText">
                        <h5>Rapid Tooling</h5>
                        <p>Because CNC machining can cut a high variety of fully dense, durable materials like aluminum 5052 and stainless steel, it is perfect for creating fixtures or molds.</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="applicationWrpp mid-child">
                    <div class="appliIco">
                        <img src="../../../../assets/images/rapid-prototyping.png" alt="">
                        <span>02</span>
                    </div>
                    <div class="appliText">
                        <h5>Rapid Prototyping</h5>
                        <p>The range of affordable metal alloys (like aluminum 6061) and plastics (like acetal) combined with the speed of our skilled machinists makes our online CNC machining a great option for prototyping.</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="applicationWrpp">
                    <div class="appliIco">
                        <img src="../../../../assets/images/End-Use-production.png" alt="">
                        <span>03</span>
                    </div>
                    <div class="appliText">
                        <h5>End-Use Production</h5>
                        <p>Performance-enhancing finishes, precision tolerances as low as +/- 0.001, and certifiable material options make CNC machining an excellent technology.</p>
                    </div>
                </div>
            </div>
            
        </div>
        <div class="text-center hide-mobile">
            <button mat-button class="btn-custom btn-solid">Get Started</button>
        </div>
    </div>
</section>

<section>
    <div class="container mxw-1100">
        <div class="row row-reverse">
            <div class="col-sm-6">
                <div class="serviceImg ml-auto">
                    <img src="../../../../assets/images/PP__6049 1.png" alt="">
                </div>
            </div>
            <div class="col-sm-6">
                <div class="serviceText">
                    <h2><span class="regular">Start</span> Manufacturing <br>
                        <span class="regular">Your Precision Machined</span> <br>
                        Components</h2>
                    <p>We provide high-quality, tight tolerance components machined from bar stock. Submit the relevant part drawings, 3D files, and other by clicking on the button below</p>
                    <button mat-button class="btn-custom btn-solid">Get Started</button>
                </div>
            </div>
            
        </div>
    </div>
</section>
